import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import BaseIntentEmptyTopicsBanner from "./BaseIntentEmptyTopicsBanner";
import { INTENT_EMPTY_TOPIC_BANNER_I18N } from "./const";

const IntentEmptyTopicsBanner = () => {
    return (
        <BaseIntentEmptyTopicsBanner
            title={<I18n translatable={INTENT_EMPTY_TOPIC_BANNER_I18N.title} />}
            description={<I18n translatable={INTENT_EMPTY_TOPIC_BANNER_I18N.description} />}
        />
    );
};

export default IntentEmptyTopicsBanner;
